import { Component } from "@angular/core";
import { BRAND_BASE_URL } from "src/constants/param-constants";

@Component({
  standalone: true,
  selector: "app-gdpr",
  template: ""
})
export class GdprComponent {
  constructor() {
    // We won't render the GDPR page, so redirecting to the brand site
    window.open(`${BRAND_BASE_URL}/gdpr/`, '_top');
  }
}
